const getters = {
    canderCards(state) {
        return state.canderCards;
    },
    addonProducts(state) {
        return state.addonProducts;
    },
    individualProducts(state) {
        return state.selectedIndividualAddons;
    },
    occasions(state) {
        return state.occasions;
    },
    categories(state) {
        return state.categories;
    },
    totalBuildPrice(state) {
        let totalPrice = 0;
        const mainProduct = state.selectedMainProduct;
        const addonProducts = state.selectedAddonProducts;
        const cardProduct = state.selectedCardProduct;

        function priceToInt(product) {
            return parseInt(product.variants[0].price.replace(".", ""));
        }

        function intToPrice(price) {
            return `$${(price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }

        if (mainProduct.variants) {
            totalPrice += priceToInt(mainProduct);
        }

        if (addonProducts.length > 0) {
            addonProducts.forEach(addon => {
                totalPrice += priceToInt(addon) * addon.quantity;
            });
        }

        if (cardProduct.variants) {
            totalPrice += priceToInt(cardProduct);
        }

        return intToPrice(totalPrice);
    },
    //New Getters
    maxCapacity(state) {
        return state.maxCapacity;
    },
    currentCapacity(state) {
        return state.selectedAddonProducts
            .filter(x => !x.tags.some(tag => tag.includes("Overflow_trigger")))
            .map(x => (x.capacity ? x.capacity * x.quantity : 0))
            .reduce((prev, next) => prev + next, 0);
    },
    selectedAddonProducts(state) {
        return state.selectedAddonProducts;
    },
    boxProducts(state) {
        return state.mainProducts;
    },
    selectedBoxProduct(state) {
        return state.selectedMainProduct;
    },
    cardProducts(state) {
        return state.cardProducts;
    },
    selectedCardProduct(state) {
        return state.selectedCardProduct;
    },
    savedCardProduct(state) {
        return state.savedCardProduct;
    },
    savedKey(state) {
        return state.savedKey;
    },
    selectedOccasion(state) {
        return state.selectedOccasion;
    },
    selectedCategories(state) {
        return state.selectedCategories;
    },
    boxQty(state) {
        return state.boxQty;
    },
    productLimit(state) {
        return state.productLimit;
    },
    selectedSort(state) {
        return state.selectedSort;
    },
    selectedFilters(state) {
        return state.selectedFilters;
    },
    rangePrice(state) {
        return state.rangePrice;
    },
    //Mobile Filter Variables START
    selectedOccasionMobile(state) {
        return state.selectedOccasionMobile;
    },
    selectedCategoriesMobile(state) {
        return state.selectedCategoriesMobile;
    },
    selectedSortMobile(state) {
        return state.selectedSortMobile;
    },
    selectedFiltersMobile(state) {
        return state.selectedFiltersMobile;
    },
    rangePriceMobile(state) {
        return state.rangePriceMobile;
    },
    //Mobile Filter Variables END
    selectedCardsOccasions(state) {
        return state.selectedCardsOccasions;
    },
    selectedCardsOccasionsMobile(state) {
        return state.selectedCardsOccasionsMobile;
    },
    boxName(state) {
        return state.boxName;
    },
    defaulBoxName(state) {
        return state.defaulBoxName;
    },
    cartNames(state) {
        return state.cartNames;
    },
    feeProduct(state) {
        return state.feeProduct;
    },
    addCopy(state) {
        return state.boxQty > 1 ? "Add to Each Box" : "Add to Box";
    },
    cartQty(state) {
        return state.cartQty;
    },
    isPage(state) {
        return state.isPage;
    },
    multishipCallout(state) {
        return state.multishipCallout;
    },
    cardHasMessage(state) {
        return state.cardHasMessage;
    },
    showCardAlert(state) {
        return state.showCardAlert;
    }
};

export default getters;
